import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getBlogImageUrl(url) {
  if (!url || typeof url !== 'string') return '';
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;

  let path = url;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const parsed = new URL(path);
      if (parsed.pathname.includes('/blog_uploads/') || parsed.pathname.includes('/blog-uploads/')) {
        path = parsed.pathname;
      } else {
        return path;
      }
    } catch {
      return path;
    }
  }

  // Normalize legacy /static/blog_uploads/ or /api/static/blog_uploads/ to /api/blog-uploads/
  if (path.startsWith('/static/blog_uploads/')) {
    path = path.replace('/static/blog_uploads/', '/api/blog-uploads/');
  } else if (path.startsWith('static/blog_uploads/')) {
    path = '/' + path.replace('static/blog_uploads/', 'api/blog-uploads/');
  } else if (path.startsWith('/api/static/blog_uploads/')) {
    path = path.replace('/api/static/blog_uploads/', '/api/blog-uploads/');
  }

  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  const cleanBase = backendUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');

  if (path.startsWith('/api/')) {
    if (typeof window !== 'undefined' && window.location && window.location.origin === cleanBase) {
      return path;
    }
    if (cleanBase) {
      return `${cleanBase}${path}`;
    }
  }

  return path;
}

